import moment from 'moment'

const requeriments_approved = {
  'BL/Booking': 'service.doc_number',
  'Contenedor': 'container_number',
  'Fecha (cita)': {
    field: 'date',
    callback: date => {
      return moment(date).isValid() ? moment(date).format('DD/MM/YYYY HH:mm') : ''
    }
  },
  'Cliente': {
    field: 'service.company',
    callback: company => {
      return company ? company.name : ''
    }
  },
  'Facturar a': {
    field: 'service.company',
    callback: company => {
      return company ? company.company_bill.name : ''
    }
  },
  'Solicitante': {
    field: 'service.applicant',
    callback: user => {
      return user ? `${user.name} ${user.last_name}` : ''
    }
  },
  'Linea naviera': {
    field: 'service.shipping_line',
    callback: shipping_line => {
      return shipping_line ? shipping_line.name : ''
    }
  },
  'Tipo de servicio': {
    field: 'service.service_type',
    callback: service_type => {
      return service_type ? service_type.name : ''
    }
  },
  'Gate In/Out': {
    field: 'tax_paid',
    callback: tax => {
      return tax ? 'Pagado' : 'No pagado'
    }
  },
}

export default requeriments_approved;